import Schema, { required } from 'AppReact/schema';

const report = {
  displayName: required('string'),
  description: required('string'),
}

export default {
  icon: Schema({}, 'object', { defaultValue: null }),
  report: Schema(report, 'object', { defaultValue: {} }),
};
